import { MicrosoftClarityScript } from '../MicrosoftClarityScript/MicrosoftClarityScript';

export const Scripts: React.FC<React.PropsWithChildren<unknown>> = () => (
  <>
    <MicrosoftClarityScript />
  </>
);
